import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { CameraServerService } from '../camera-server.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from '../../components/spinner-component/spinner.service';
import { MatDialog } from '@angular/material/dialog';
import { AppConstants } from '../../shared/app-constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogueComponent } from 'src/app/components/confirmation-dialogue/confirmation-dialogue.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
export interface TableElement {
  id: number;
  potentialName: string;
  status: string;
}

@Component({
  selector: 'app-footage-queue-list',
  templateUrl: './footage-queue-list.component.html',
  styleUrls: ['./footage-queue-list.component.scss']
,
  standalone: false
})
export class FootageQueueListComponent implements OnInit {

  loading: boolean = false;
  displayedColumns: string[] = ['ui_created_date', 'id', 'potentialName', 'cam_name', 'date_range', 'status', 'reported_by', 'size', 'action'];
  dataSource = new MatTableDataSource<TableElement>([]);
  dataSourceArray: any = [];
  selection = new SelectionModel<TableElement>(true, []);
  totalRecords: number;
  pageSize: number = 25;
  pageNumber: number = 0;
  selectRow: any = [];
  selectAllRow: any = [];
  isDownloadShow: boolean = false;

  constructor(
    private camService: CameraServerService,
    private toasts: ToastrService,
    public spinner: SpinnerService,
    public dialog: MatDialog,
    private ngbModalService: NgbModal,
    private authService: AuthenticationService
  ) { }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.getFootageDownloadQueue(this.pageNumber, this.pageSize);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.pageNumber = this.paginator.pageIndex;
    this.pageSize = this.paginator.pageSize;
    this.sort.active
    this.sort.direction
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
  }

  parseDate(dateStr: string): Date {
    const [dayWithSuffix, timeFormat] = dateStr.split(' ');
    const [dayNumber, month, year] = dayWithSuffix.split("-");
    const [hours, minutes, seconds] = timeFormat.split(":");

    const day = parseInt(dayNumber.match(/\d+/)[0]);
    const months = {
      'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3,
      'May': 4, 'Jun': 5, 'Jul': 6, 'Aug': 7,
      'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11
    };

    return new Date(+year, months[month], day, Number(hours), Number(minutes), Number(seconds));
  }

  dateRangeDiff(fromDateStr: string, toDateStr: string): string {
    const fromDate = new Date(fromDateStr);
    const toDate = new Date(toDateStr);
    const diffTime = Math.abs(toDate.getTime() - fromDate.getTime());
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
    if (diffDays > 0) {
      return `${diffDays}d ${diffHours}h ${diffMinutes}m`;
    } else if (diffHours > 0) {
      return `${diffHours}h ${diffMinutes}m`;
    } else {
      return `${diffMinutes}m`;
    }
  }

  getFootageDownloadQueue(pageNumber: any, pageSize: any) {
    const currentUser: any = this.authService.currentUserValue;
    let userName = "";
    if (currentUser['role'] && currentUser['role'].length > 0) {
      if (currentUser['role'][0]?.toLowerCase() === 'admin') {
        userName = "";
      } else {
        userName = currentUser?.firstName;
      }
    }
    this.spinner.activate();
    this.loading = true;
    this.camService.footageDownloadQueue(pageNumber + 1, pageSize, userName).subscribe((response: any) => {
      if (response && response.success) {
        this.spinner.deactivate();
        this.loading = false;
        response.data.map(item => {
          item.ui_created_date = this.parseDate(item?.created_date);
          item.ui_to_date = this.parseDate(item?.to_date)
          item.ui_from_date = this.parseDate(item?.from_date);
          item.ui_to_date = this.parseDate(item?.to_date);
        });

        let sortedData = response.data.filter(item => item.ui_created_date);
        sortedData.sort((a, b) => b.ui_created_date.getTime() - a.ui_created_date.getTime());
        this.dataSourceArray = sortedData;
        this.dataSource = new MatTableDataSource(sortedData);
        this.totalRecords = response.total;
        // this.paginator.length = this.totalRecords;
        this.dataSource.sort = this.sort;
        this.sort.active = 'ui_created_date';
        this.sort.direction = "desc";
        // this.sort.sortChange.emit();
      } else {
        this.spinner.deactivate();
        this.loading = false;
        this.toasts.error(response?.message || AppConstants.defaultErrorMessage);
      }
    }, err => {
      this.loading = false;
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toasts.error(err.error.message, 'Error');
      } else {
        this.toasts.error(AppConstants.defaultErrorMessage, 'Error');
      }
    });
  }

  updatePaginatedData() {
    //const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    //const endIndex = startIndex + this.paginator.pageSize;
    //const paginatedData = this.dataSourceArray.slice(startIndex, endIndex);
    // this.dataSource = new MatTableDataSource<TableElement>(paginatedData);
  }

  changePaging(event: any) {
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getFootageDownloadQueue(event.pageIndex, event.pageSize);
  }

  sortData(sort: Sort) {
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = this.dataSourceArray;
      return;
    }
    const mbToKb: any = (inputString: any) => {
      if (!inputString || inputString.trim() === "") {
        return "";
      }
      inputString = inputString.trim();

      if (inputString.endsWith("KB")) {
        const kbValue = inputString.slice(0, -2).trim();
        if (isNaN(parseFloat(kbValue))) {
          return "Invalid number";
        }
        return parseFloat(kbValue);
      }

      if (inputString.endsWith("MB")) {
        const mbValue = inputString.slice(0, -2).trim();
        if (isNaN(parseFloat(mbValue))) {
          return "Invalid number";
        }
        const kilobytes = parseFloat(mbValue) * 1024;
        return kilobytes;
      }

      if (inputString.endsWith("GB")) {
        const gbValue = inputString.slice(0, -2).trim();
        const gbFloat = parseFloat(gbValue);
        if (isNaN(gbFloat)) {
          return "Invalid number";
        }
        const kilobytes = gbFloat * 1024 * 1024;
        return kilobytes;
      }

      return "Invalid input format";
    }

    const isAsc = sort.direction === 'asc';
    this.dataSourceArray.sort((a: any, b: any) => {
      switch (sort.active) {
        case 'ui_created_date': return this.compare(a.ui_created_date, b.ui_created_date, isAsc);
        case 'status': return this.compare(a.status, b.status, isAsc);
        case 'size': {
          return this.compare(a.file_size ? mbToKb(a.file_size) : '', b.file_size ? mbToKb(b.file_size) : '', isAsc);
        }
        case 'date_range':
          return this.compare(a.ui_from_date, b.ui_from_date, isAsc);
        case 'id':
          return this.compare(a.potential_id, b.potential_id, isAsc);
        case 'potentialName':
          return this.compare(a.site_name, b.site_name, isAsc);
        case 'reported_by':
          return this.compare(a.user_name, b.user_name, isAsc);
        default: return 0;
      }
    });
    this.dataSource = new MatTableDataSource<TableElement>(this.dataSourceArray);
  }

  compare(a: Date, b: Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  resetSorting() {
    const sortState: Sort = { active: 'ui_created_date', direction: 'desc' };
    this.sortData(sortState);
  }

  selectedRow(event: any, row: any) {
    event.stopPropagation();
  }

  handleDownload(element: any) {
    this.loading = true;
    this.spinner.activate();
    this.camService.footageDownloadUsingS3(element?.s3_url)
      .subscribe(data => {
        const blob = new Blob([data.Body], { type: data.ContentType });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${element?.potential_id}.mp4`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        this.loading = false;
        this.spinner.deactivate();
      }, err => {
        this.loading = false;
        this.spinner.deactivate();
        if (err && err.error && err.error.message && err.error.message.length > 0) {
          this.toasts.error(err.error.message, 'Error');
        } else {
          this.toasts.error(AppConstants.defaultErrorMessage, 'Error');
        }
      });
  }

  copyURL(url) {
    const unsecuredCopyToClipboard = (text: any) => {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
      }
      document.body.removeChild(textArea);
    };
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(url);
    } else {
      unsecuredCopyToClipboard(url);
    }
    this.toasts.success("Footage clip url copied!");
  }

  cancelFootage(process_id: number) {
    let popupData = {
      title: "Confirmation?",
      message: `Are you sure you want to cancel the footage download process?`,
      cancelBtnText: "No",
      confirmBtnText: "Yes"
    }
    let dialogs = this.ngbModalService.open(ConfirmationDialogueComponent);
    dialogs.componentInstance._data = popupData;
    dialogs.result.then(data => {
      if (data) {
        this.loading = true;
        this.spinner.activate();
        this.camService.cancelFootageDownload(process_id)
          .subscribe(response => {
            this.loading = false;
            this.spinner.deactivate();
            if (response && response.success) {
              this.getFootageDownloadQueue(this.pageNumber, this.pageSize);
              this.toasts.success(`The camera footage got canceled - ${response?.data?.cam_name}` || '')
            } else {
              this.loading = false;
              this.spinner.deactivate();
              this.toasts.error(AppConstants.defaultErrorMessage, 'Error');
            }
          }, err => {
            this.loading = false;
            this.spinner.deactivate();
            if (err && err.error && err.error.message && err.error.message.length > 0) {
              this.toasts.error(err.error.message, 'Error');
            } else {
              this.toasts.error(AppConstants.defaultErrorMessage, 'Error');
            }
          });
      }
    })
  }
}